import ApiService from "@/common/api/api.service";


const ROL = {
    listar(empresaId, ano,anoFim, mesInicio, mesFim, tamanhoDaPagina = 0, numeroDaPagina = 0) {
        return ApiService.get(`Rol?Ano=${ano}${anoFim ? `&AnoFim=${anoFim}` : ''}${mesInicio ? `&MesInicio=${mesInicio}` : ''}${mesFim ? `&MesFim=${mesFim}`: ''}&EmpresaId=${empresaId}&TamanhoDaPagina=${tamanhoDaPagina}&NumeroDaPagina=${numeroDaPagina}`);
    },

    salvar(form) {
        if(form.id)
            return ApiService.put(`Rol`, form);
        return ApiService.post("Rol", form);
    },

    deletar(id) {
        return ApiService.delete(`Rol`,{id});
    },

    salvarReceita(form) {
        if(form.id)
            return ApiService.put(`Rol/receita`, form);
        return ApiService.post(`Rol/receita`, form);
    },

    removerReceita(id) {
        return ApiService.delete(`Rol/receita`, { id });
    },

    salvarDeducao(form) {
        if(form.id)
            return ApiService.put(`Rol/deducao`, form);
        return ApiService.post(`Rol/deducao`, form);
    },

    removerDeducao(id) {
        return ApiService.delete(`Rol/deducao`, { id });
    },
}

export default ROL;
